import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between px-6 pt-6 pb-4 border-b border-black/[0.06]" }
const _hoisted_2 = { class: "text-[1.5rem] font-semibold text-[#0f1f2e]" }
const _hoisted_3 = { class: "py-2" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 0,
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  class: "text-[#7a9aaa]"
}
const _hoisted_7 = {
  key: 1,
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#9dc0fd",
  "stroke-width": "3",
  "stroke-linecap": "round"
}
const _hoisted_8 = { class: "px-6 pb-6 pt-1" }
const _hoisted_9 = { class: "bg-slate-50 rounded-xl px-3 py-2.5 text-[12px] text-[#7a9aaa] font-mono truncate" }

import { useLiveGroups } from "@/components/companionGroups/useLiveGroups";
import PopUp from "@/components/popup/PopUp.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SharePopup',
  props: {
    isOpen: { type: Boolean },
    url: {},
    whatsappUrl: {},
    telegramUrl: {},
    copied: { type: Boolean }
  },
  emits: ["close", "copy"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const { t } = useLiveGroups(
  { _skipInit: true },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  (_e: any, ..._args: any[]) => {},
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopUp, {
    "model-value": __props.isOpen,
    size: "sm",
    align: "bottom",
    "onUpdate:modelValue": _cache[4] || (_cache[4] = v => !v && emit('close'))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)("invitePeople")), 1),
        _createElementVNode("button", {
          class: "w-8 h-8 rounded-full hover:bg-slate-100 flex items-center justify-center text-slate-400 transition",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round"
          }, [
            _createElementVNode("line", {
              x1: "18",
              y1: "6",
              x2: "6",
              y2: "18"
            }),
            _createElementVNode("line", {
              x1: "6",
              y1: "6",
              x2: "18",
              y2: "18"
            })
          ], -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          href: __props.whatsappUrl,
          target: "_blank",
          rel: "noopener",
          class: "flex items-center gap-4 px-6 py-4 hover:bg-slate-50 transition",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
        }, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("div", { class: "w-10 h-10 rounded-full bg-[#e8f9ee] flex items-center justify-center flex-shrink-0" }, [
            _createElementVNode("svg", {
              width: "20",
              height: "20",
              viewBox: "0 0 24 24",
              fill: "currentColor",
              class: "text-[#25d366]"
            }, [
              _createElementVNode("path", { d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" })
            ])
          ], -1),
          _createElementVNode("span", { class: "text-[1.4rem] font-medium text-[#0f1f2e]" }, "WhatsApp", -1)
        ]))], 8, _hoisted_4),
        _createElementVNode("a", {
          href: __props.telegramUrl,
          target: "_blank",
          rel: "noopener",
          class: "flex items-center gap-4 px-6 py-4 hover:bg-slate-50 transition",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
        }, [...(_cache[7] || (_cache[7] = [
          _createElementVNode("div", { class: "w-10 h-10 rounded-full bg-[#e5f4fb] flex items-center justify-center flex-shrink-0" }, [
            _createElementVNode("svg", {
              width: "20",
              height: "20",
              viewBox: "0 0 24 24",
              fill: "currentColor",
              class: "text-[#229ed9]"
            }, [
              _createElementVNode("path", { d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.333-.373-.12L7.17 13.4l-2.945-.924c-.64-.203-.653-.64.136-.953l11.57-4.461c.537-.194 1.006.131.963.159z" })
            ])
          ], -1),
          _createElementVNode("span", { class: "text-[1.4rem] font-medium text-[#0f1f2e]" }, "Telegram", -1)
        ]))], 8, _hoisted_5),
        _createElementVNode("button", {
          class: "flex items-center gap-4 px-6 py-4 hover:bg-slate-50 transition w-full text-left",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('copy')))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 transition", __props.copied ? 'bg-[#edf3ff]' : 'bg-slate-100'])
          }, [
            (!__props.copied)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("rect", {
                    x: "9",
                    y: "9",
                    width: "13",
                    height: "13",
                    rx: "2"
                  }, null, -1),
                  _createElementVNode("path", { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" }, null, -1)
                ]))]))
              : (_openBlock(), _createElementBlock("svg", _hoisted_7, [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                ]))]))
          ], 2),
          _createElementVNode("span", {
            class: _normalizeClass(["text-[1.4rem] font-medium", __props.copied ? 'text-[#4a7fd4]' : 'text-[#0f1f2e]'])
          }, _toDisplayString(__props.copied ? _unref(t)("shareCopied") : _unref(t)("shareCopy")), 3)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(__props.url), 1)
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})